module.exports = __webpack_public_path__ + "media/images/athletes/3468-a890629eb74de8c3e53f97859242ba45.png";